/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Spaces_Webhook_Address_TitleInputs */



/**
* | output |
* | --- |
* | "One last step in {name}" |
*
* @param {Spaces_Webhook_Address_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_webhook_address_title = /** @type {((inputs: Spaces_Webhook_Address_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Webhook_Address_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ein letzter Schritt in ${i?.name}`)
	return /** @type {LocalizedString} */ (`One last step in ${i?.name}`)
});